"use strict";
//
// Copyright © 2020 Anticrm Platform Contributors.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.pongConst = exports.pingConst = exports.ClientSocketReadyState = exports.clientId = void 0;
const platform_1 = require("@hcengineering/platform");
/**
 * @public
 */
exports.clientId = 'client';
/**
 * @public
 */
var ClientSocketReadyState;
(function (ClientSocketReadyState) {
    ClientSocketReadyState[ClientSocketReadyState["CONNECTING"] = 0] = "CONNECTING";
    ClientSocketReadyState[ClientSocketReadyState["OPEN"] = 1] = "OPEN";
    ClientSocketReadyState[ClientSocketReadyState["CLOSING"] = 2] = "CLOSING";
    ClientSocketReadyState[ClientSocketReadyState["CLOSED"] = 3] = "CLOSED";
})(ClientSocketReadyState || (exports.ClientSocketReadyState = ClientSocketReadyState = {}));
exports.pingConst = 'ping';
exports.pongConst = 'pong!';
exports.default = (0, platform_1.plugin)(exports.clientId, {
    metadata: {
        ClientSocketFactory: '',
        FilterModel: '',
        ExtraFilter: '',
        ExtraPlugins: '',
        UseBinaryProtocol: '',
        UseProtocolCompression: '',
        ConnectionTimeout: '',
        OverridePersistenceStore: ''
    },
    function: {
        GetClient: ''
    }
});
//# sourceMappingURL=index.js.map